import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import SstoaApp from './sstoa/SstoaApp';
import LaonaApp from './laona/LaonaApp';
import { AuthProvider } from './site/auth';
import { CartProvider } from './site/cart';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
        <Routes>
          {/* 공개 마케팅 사이트 */}
          <Route path="/*" element={<App />} />
          {/* 라오나봇 — 별도 프로젝트처럼 보이는 하위 사이트 (헤더·푸터·브랜드 분리) */}
          <Route path="/laonabot/*" element={<LaonaApp />} />
          {/* SSTOA 회사 관리 ERP */}
          <Route path="/sstoa/*" element={<SstoaApp />} />
        </Routes>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
